export interface ReportAccessGrantConstructor {
  id: number
  userFirstName: string
  userLastName: string
}

export class ReportAccessGrant {
  readonly id: number
  readonly userFirstName: string
  readonly userLastName: string

  constructor(data: ReportAccessGrantConstructor) {
    this.id = data.id
    this.userFirstName = data.userFirstName
    this.userLastName = data.userLastName
  }

  get userFullName(): string {
    return `${this.userFirstName} ${this.userLastName}`
  }
}
